import { API } from "../constants/api";
import { axiosPostWithToken, axiosGetWithToken } from "../services/apiServices";
import { ERROR_ALERT, } from "./commonAction";
import { CHANGE_VIEW_PROJECT_TAB } from "./viewProjectTabAction";

export const GET_WORKFLOW_FLEXIFIT = "GET_WORKFLOW_FLEXIFIT";
export const WORKFLOW_FLEXIFIT_LOADING = "WORKFLOW_FLEXIFIT_LOADING";
export const SET_WORKFLOW_FLEXIFIT_ITEMS_PER_PAGE =
  "SET_WORKFLOW_FLEXIFIT_ITEMS_PER_PAGE";
export const CHANGE_CURRENT_WORKFLOW_FLEXIFIT_PAGE =
  "CHANGE_CURRENT_WORKFLOW_FLEXIFIT_PAGE";
export const SEARCH_WORKFLOW_FLEXIFIT = "SEARCH_WORKFLOW_FLEXIFIT";
export const FILTER_WORKFLOW_FLEXIFIT_ROLES = "FILTER_WORKFLOW_FLEXIFIT_ROLES";
export const FILTER_WORKFLOW_FLEXIFIT_SKILLS =
  "FILTER_WORKFLOW_FLEXIFIT_SKILLS";
export const WORKFLOW_FLEXIFIT_MIN_REL_EXP = "WORKFLOW_FLEXIFIT_MIN_REL_EXP";
export const WORKFLOW_FLEXIFIT_MAX_REL_EXP = "WORKFLOW_FLEXIFIT_MAX_REL_EXP";
export const WORKFLOW_FLEXIFIT_FILTER_REL_EXP =
  "WORKFLOW_FLEXIFIT_FILTER_REL_EXP";
export const WORKFLOW_FLEXIFIT_SET_TABLE_SELECTED_ROWS =
  "WORKFLOW_FLEXIFIT_SET_TABLE_SELECTED_ROWS";
export const RESET_WORKFLOW_FLEXIFIT = "RESET_WORKFLOW_FLEXIFIT";
export const FILTER_WORKFLOW_FLEXIFIT_STATUS =
  "FILTER_WORKFLOW_FLEXIFIT_STATUS";
export const WORKFLOW_FLEXIFIT_SET_HASDONE_FILTER =
  "WORKFLOW_FLEXIFIT_SET_HASDONE_FILTER";
export const WORKFLOW_FLEXIFIT_SET_MATCHING_FILTER =
  "WORKFLOW_FLEXIFIT_SET_MATCHING_FILTER";
export const WORKFLOW_FLEXIFIT_MIN_TOTAL_EXP =
  "WORKFLOW_FLEXIFIT_MIN_TOTAL_EXP";
export const WORKFLOW_FLEXIFIT_MAX_TOTAL_EXP =
  "WORKFLOW_FLEXIFIT_MAX_TOTAL_EXP";
export const WORKFLOW_FLEXIFIT_FILTER_TOTAL_EXP =
  "WORKFLOW_FLEXIFIT_FILTER_TOTAL_EXP";

export const WORKFLOW_FLEXIFIT_VIEW_CLIENT_FEEDBACK =
  "WORKFLOW_FLEXIFIT_VIEW_CLIENT_FEEDBACK";
export const WORKFLOW_FLEXIFIT_VIEW_FLEXIFIT_FEEDBACK =
  "WORKFLOW_FLEXIFIT_VIEW_FLEXIFIT_FEEDBACK";
export const FILTER_WORKFLOW_FLEXIFIT_AVAILABLE_HOURS =
  "FILTER_WORKFLOW_FLEXIFIT_AVAILABLE_HOURS";
export const VIEW_WORKFLOW_CANDIDATE_TIMELINE =
  "VIEW_WORKFLOW_CANDIDATE_TIMELINE";

export const FILTER_WORKFLOW_FLEXIFIT_FLEXIBEES_SELECTED =
  "FILTER_WORKFLOW_FLEXIFIT_FLEXIBEES_SELECTED";

export const FILTER_WORKFLOW_FLEXIFIT_ACTIVE_PROJECTS =
  "FILTER_WORKFLOW_FLEXIFIT_ACTIVE_PROJECTS";



export const getFlexifit = (projectId, closeModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    const pagesize = getstate().workflowFlexifit.workflowFlexifitResultsPerPage;
    const page = getstate().workflowFlexifit.workflowFlexifitCurrentPage;
    const seachText = getstate().workflowFlexifit.workflowFlexifitSearchText;
    const roles =
      getstate().workflowFlexifit.workflowFlexifitAppliedRolesFilter;
    const skills =
      getstate().workflowFlexifit.workflowFlexifitAppliedSkillsFilter;
    const total_available_hours =
      getstate().workflowFlexifit.workflowFlexifitAppliedAvailableHoursFilter;
    const status =
      getstate().workflowFlexifit.workflowFlexifitAppliedStatusFilter;
    const minRelExp =
      getstate().workflowFlexifit.workflowFlexifitAppliedMinRelExpFilter;
    const maxRelExp =
      getstate().workflowFlexifit.workflowFlexifitAppliedMaxRelExpFilter;
    const minTotalExp =
      getstate().workflowFlexifit.workflowFlexifitAppliedMinTotalExpFilter;
    const maxTotalExp =
      getstate().workflowFlexifit.workflowFlexifitAppliedMaxTotalExpFilter;
    const matching =
      getstate().workflowFlexifit.workflowFlexifitAppliedMatchingFilter === "0"
        ? false
        : true;

    const flexibees_selected =
      getstate().workflowFlexifit.candidatesListApplaiedFilterFlexiSelected;
    const active_projects =
      getstate().workflowFlexifit.candidatesListApplaiedFilterActiveProjects;

    const body = {
      search_term: seachText,
      filter_data: {
        roles: roles,
        skills: skills,
        status: status,
        final_selection: matching,
        flexibees_selected: flexibees_selected,
        active_projects: active_projects,
        relevant_experience: {
          min: minRelExp,
          max: maxRelExp,
        },
        years_of_experience: {
          min: minTotalExp,
          max: maxTotalExp,
        },
        total_available_hours: total_available_hours,
      },
    };

    axiosPostWithToken(
      `${API.GET_WORKFLOW_FLEXIFIT}/${projectId}/${pagesize}/${page}/`,
      body,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: GET_WORKFLOW_FLEXIFIT,
          payload: res.data.data,
        });
        if (closeModal) {
          closeModal();
        }
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload:
            (res.data && res.data.data && res.data.data.message) ||
            "Something went wrong. Unable to fetch data.",
        });
      }
    });
  };
};

export const resetTableData = () => {
  return async (dispatch) => {
    dispatch({
      type: CHANGE_VIEW_PROJECT_TAB,
      payload: 0,
    });
    dispatch({
      type: RESET_WORKFLOW_FLEXIFIT,
    });
  };
};

export const sendFlexifitNotification = (body, refresh) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;

    axiosPostWithToken(`${API.SEND_FLEXIFIT_NOTIFICATION}`, body, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          refresh();
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload:
              (res.data && res.data.data && res.data.data.message) ||
              "Something went wrong. Unable to process request.",
          });
        }
      }
    );
  };
};

export const setItemsPerPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: SET_WORKFLOW_FLEXIFIT_ITEMS_PER_PAGE,
      payload: value,
    });
  };
};

export const changeCurrentPage = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: CHANGE_CURRENT_WORKFLOW_FLEXIFIT_PAGE,
      payload: value,
    });
  };
};

export const search = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: SEARCH_WORKFLOW_FLEXIFIT,
      payload: value,
    });
  };
};

export const filterRoles = (roles) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: FILTER_WORKFLOW_FLEXIFIT_ROLES,
      payload: roles,
    });
  };
};

export const filterSkills = (skills) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: FILTER_WORKFLOW_FLEXIFIT_SKILLS,
      payload: skills,
    });
  };
};

export const filterStatus = (status) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: FILTER_WORKFLOW_FLEXIFIT_STATUS,
      payload: status,
    });
  };
};

export const filterAvailableHours = (hours) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: FILTER_WORKFLOW_FLEXIFIT_AVAILABLE_HOURS,
      payload: hours,
    });
  };
};

export const changeMinRelExp = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_MIN_REL_EXP,
      payload: value,
    });
  };
};

export const changeMaxRelExp = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_MAX_REL_EXP,
      payload: value,
    });
  };
};

export const clearRelExpFilter = (value, filterData) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_MIN_REL_EXP,
      payload: value,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_MAX_REL_EXP,
      payload: value,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_FILTER_REL_EXP,
      payload: false,
    });
    filterData();
  };
};

export const filterRelExp = (filterData) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_FILTER_REL_EXP,
      payload: true,
    });
    filterData();
  };
};

export const changeMinTotalExp = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_MIN_TOTAL_EXP,
      payload: value,
    });
  };
};

export const changeMaxTotalExp = (value) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_MAX_TOTAL_EXP,
      payload: value,
    });
  };
};

export const clearTotalExpFilter = (value, filterData) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_MIN_TOTAL_EXP,
      payload: value,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_MAX_TOTAL_EXP,
      payload: value,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_FILTER_TOTAL_EXP,
      payload: false,
    });
    filterData();
  };
};

export const filterTotalExp = (filterData) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_FILTER_TOTAL_EXP,
      payload: true,
    });
    filterData();
  };
};

export const setTableRows = (rows) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_SET_TABLE_SELECTED_ROWS,
      payload: rows,
    });
  };
};

export const setHasDoneFilter = (data) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_SET_HASDONE_FILTER,
      payload: data,
    });
  };
};

export const setMatchingFilter = (data) => {
  return async (dispatch) => {
    dispatch({
      type: WORKFLOW_FLEXIFIT_LOADING,
    });
    dispatch({
      type: WORKFLOW_FLEXIFIT_SET_MATCHING_FILTER,
      payload: data,
    });
  };
};

export const getClientFeedback = (final_selection_id, toggleModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(
      `${API.VIEW_CLIENT_FEEDBACK}/${final_selection_id}/`,
      token
    ).then((res) => {
      if (res.data.status_code === 200) {
        dispatch({
          type: WORKFLOW_FLEXIFIT_VIEW_CLIENT_FEEDBACK,
          payload: res.data.data,
        });
        toggleModal("ViewClientFeedback");
      } else {
        dispatch({
          type: ERROR_ALERT,
          payload: "Something went wrong. Unable to fetch data.",
        });
        console.log(`Error: ${res.data.data.message}`);
      }
    });
  };
};

export const getFlexifitFeedback = (id, toggleModal) => {
  return async (dispatch, getstate) => {
    const token = getstate().auth.token;
    axiosGetWithToken(`${API.VIEW_FLEXIFIT_FEEDBACK}/${id}/`, token).then(
      (res) => {
        if (res.data.status_code === 200) {
          dispatch({
            type: WORKFLOW_FLEXIFIT_VIEW_FLEXIFIT_FEEDBACK,
            payload: res.data.data,
          });
          toggleModal("ViewFlexifitFeedback");
        } else {
          dispatch({
            type: ERROR_ALERT,
            payload: "Something went wrong. Unable to fetch data.",
          });
          console.log(`Error: ${res.data.data.message}`);
        }
      }
    );
  };
};




export const setFlexibeesSelectedFilter = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FILTER_WORKFLOW_FLEXIFIT_FLEXIBEES_SELECTED,
      payload: value,
    });
  };
};

export const setActiveProjectsFilter = (value) => {
  return async (dispatch) => {
    dispatch({
      type: FILTER_WORKFLOW_FLEXIFIT_ACTIVE_PROJECTS,
      payload: value,
    });
  };
};
